import React from 'react';
import './Monitor.css';

const DASHBOARD_UID = '5b0f7590-d27d-4591-8b88-9c5c64997a7a';
const DASHBOARD_SLUG = 'monitor-seguridad';
const THEME = 'dark';
const FROM = 'now-6h';
const TO = 'now';

const Monitor = () => {
  const GRAFANA_BASE = import.meta.env.VITE_API_URL;
  const iframeUrl = `${GRAFANA_BASE}/d/${DASHBOARD_UID}/${DASHBOARD_SLUG}?orgId=1&kiosk&theme=${THEME}&from=${FROM}&to=${TO}`;

  return (
    <div className="monitor-seguridad">
      <header className="monitor-header">
        <h1> 💻 Monitor de seguridad</h1>
      </header>
      <div className="monitor-iframe-container">
        <iframe
          src={iframeUrl}
          title="Dashboard Grafana - Seguridad"
          className="monitor-grafana-iframe"
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
          allow="fullscreen"
        />
      </div>
    </div>
  );
};

export default Monitor;
